<script lang="ts">
  import { i18nInitialize } from '@translation';

  import { Layout } from '@core/components';

  import { activeRouteComponent, Path, router } from '@router';

  import { LoadingSpinner } from '@shared/components';
  import { Toasts } from '@shared/features';
  import { authService, officeService, storageService } from '@shared/services';
  import { initProfiles, profiles } from '@shared/stores';

  $: isLoadingAppInfo = true;

  const handleI18nInitialize = async (): Promise<void> => {
    const lang = officeService.getOfficeLanguage();
    await i18nInitialize(lang);
  };

  Office.onReady(async () => {
    console.log(`Quickshare v${process.env.APP_VERSION}`);
    await handleI18nInitialize();

    await storageService.initTokenCache();
    await initProfiles();

    const storageActiveToken = storageService.cachedToken;

    if (storageActiveToken) {
      authService.getMe({
        payload: storageActiveToken,
        onSuccess: () => {
          router.navigate(Path.FILES);
          isLoadingAppInfo = false;
        },
        onError: () => (isLoadingAppInfo = false),
      });
    } else if (Object.keys($profiles).length) {
      router.navigate(Path.PROFILES);
      isLoadingAppInfo = false;
    } else {
      isLoadingAppInfo = false;
    }
  });
</script>

<div data-component="Quickshare" class="wrapper">
  {#if isLoadingAppInfo}
    <div class="loader-wrapper">
      <LoadingSpinner />
    </div>
  {:else}
    <Layout>
      <svelte:component this={$activeRouteComponent} />
    </Layout>
  {/if}

  <Toasts />
</div>

<style lang="scss">
  .wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;
    min-height: 100%;
  }

  .loader-wrapper {
    @include app-loading-wrapper;
  }
</style>
